import styled from '@emotion/styled';

export const Anchor = styled.a`
  color: inherit;

  &:hover {
    color: inherit;
  }
`;
